import script from "./FormCompaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCompaComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormCompaComponent.vue?vue&type=style&index=0&id=43896454&scoped=true&lang=css"
import "./FormCompaComponent.vue?vue&type=style&index=1&id=43896454&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43896454"]])

export default __exports__